import { List, Map as ImmutableMap, fromJS } from 'immutable';
import { DEFAULT_LANGUAGE } from '../../../config/constants';

import {
  ROOT_CLASSES_ADD,
  ROOT_CLASSES_REMOVE,
  LANGUAGE_SET,
  DISABLE_MAINTENANCE_MODE,
  ENABLE_MAINTENANCE_MODE,
  SET_CHECKBOX,
  SHOW_MOBILE_MENU,
  HIDE_MOBILE_MENU,
  PREV_ORDER_NUMBER_SET,
  PREV_ORDER_INFO_SET,
  VOCABULARY_LOADED,
  SET_DEVICE_SIZE,
  SET_PAGE_INFORMATION,
  CLEAR_PAGE_INFORMATION,
  SET_SEARCH_PARAMS,
  SET_PAGEVIEW_SENT,
  SET_CALCULATOR_LOCATIONS_COUNT,
  SET_NEWSLETTER_CONTACT_PROPERTY_OPTIONS,
  SET_NEWSLETTER_CONTACT,
} from '../../actions/UI';

import {
  REFERENCE_LOADING_START,
  REFERENCE_LOADING_DONE,
  REFERENCE_LOADING_RESET,
  REFERENCE_LOADING_ENABLE_PAGE_LOADER,
} from '../../actions/UI/ReferenceLoading';

const initialState = fromJS({
  language: DEFAULT_LANGUAGE,
  rootClasses: [],
  maintenanceMode: false,
  searchParams: '',
  showMobileMenu: false,
  referenceLoading: {
    itemsStarted: null,
    itemsFinished: null,
  },
  pageInformation: null,
  prevOrderNumber: null,
  prevOrderInfo: null,
  pageViewSent: false,
  currentUrl: '',
  previousUrl: '',
  deviceSize: new ImmutableMap(),
  calculatorLocationsCount: 0,
  newsletter: {
    contact_property_options: {},
    contact: undefined,
  },
});

export default function ui(state = initialState, action = {}) {
  switch (action.type) {
    case ENABLE_MAINTENANCE_MODE: {
      return state.set('maintenanceMode', true);
    }

    case DISABLE_MAINTENANCE_MODE: {
      return state.set('maintenanceMode', false);
    }

    case LANGUAGE_SET: {
      return state.set('language', action.language);
    }

    case PREV_ORDER_NUMBER_SET: {
      return state.set('prevOrderNumber', action.orderNumber);
    }

    case PREV_ORDER_INFO_SET: {
      return state.set('prevOrderInfo', fromJS({
        isElearning: action.isElearning,
        isFreeProduct: action.isFreeProduct,
        productType: action.productType,
      }));
    }

    case SET_SEARCH_PARAMS: {
      return state.set('searchParams', action.searchParams);
    }

    case REFERENCE_LOADING_ENABLE_PAGE_LOADER: {
      return state.setIn(['referenceLoading', 'showPageLoader'], true);
    }

    case REFERENCE_LOADING_START: {
      const current = state.getIn(['referenceLoading', 'itemsStarted']);
      return state.setIn(['referenceLoading', 'itemsStarted'], current + 1);
    }

    case REFERENCE_LOADING_RESET: {
      return state.set('referenceLoading', initialState.get('referenceLoading'));
    }

    case SET_CHECKBOX: {
      return state.setIn(['webformState', action.id], action.checked);
    }

    case REFERENCE_LOADING_DONE: {
      const current = state.getIn(['referenceLoading', 'itemsFinished']);
      return state.setIn(['referenceLoading', 'itemsFinished'], current + 1);
    }

    case SHOW_MOBILE_MENU: {
      return state.set('showMobileMenu', true);
    }

    case HIDE_MOBILE_MENU: {
      return state.set('showMobileMenu', false);
    }

    case SET_DEVICE_SIZE: {
      return state.set('deviceSize', new ImmutableMap(action.deviceSize));
    }

    case CLEAR_PAGE_INFORMATION: {
      return state.set('pageInformation', null);
    }

    case SET_PAGEVIEW_SENT: {
      return state.set('pageViewSent', action.value);
    }

    case SET_PAGE_INFORMATION: {
      return state.set('pageInformation', {
        title: action.title,
        ...action.metadata,
      });
    }

    case ROOT_CLASSES_ADD: {
      const classes = List(
        typeof action.classes === 'string'
          ? action.classes.split(' ')
          : action.classes,
      );

      // Filter on those that we have to add.
      const newClasses = classes.filter((item) => {
        const index = state.get('rootClasses').findIndex((c) => c === item);
        return index === -1;
      });

      return state
        .update('rootClasses', (list) => list.merge(newClasses));
    }

    case ROOT_CLASSES_REMOVE: {
      const classes = List(
        typeof action.classes === 'string'
          ? action.classes.split(' ')
          : action.classes,
      );

      return state
        .update('rootClasses', (list) => list.filter((item) => {
          const index = classes.findIndex((c) => c === item);
          return index === -1;
        }));
    }

    case VOCABULARY_LOADED: {
      const entities = action.data.get('entities');
      if (entities && entities.size > 0) {
        const vocabularyName = entities.getIn([0, 'vid', 0, 'target_id']);
        return state.setIn(['vocabularies', vocabularyName], entities);
      }
      return state;
    }

    case '@@router/LOCATION_CHANGE': {
      return state.set('previousUrl', state.getIn(['currentUrl'])).set('currentUrl', action.payload);
    }

    case SET_CALCULATOR_LOCATIONS_COUNT: {
      return state.set('calculatorLocationsCount', action.locationsCount);
    }

    case SET_NEWSLETTER_CONTACT_PROPERTY_OPTIONS: {

      const permissions = action.data.filter((entry) => entry.name === 'permissions')[0].entries;
      const list1 = action.data.filter((entry) => entry.name === 'list1')[0].entries;
      const list2 = action.data.filter((entry) => entry.name === 'list2')[0].entries;

      return state.setIn(['newsletter', 'contact_property_options', 'permissions'], permissions)
        .setIn(['newsletter', 'contact_property_options', 'list1'], list1)
        .setIn(['newsletter', 'contact_property_options', 'list2'], list2);
    }

    case SET_NEWSLETTER_CONTACT: {
      return state.setIn(['newsletter', 'contact'], action.data);
    }

    default:
      return state;
  }
}
